export default function visibilityTypes(state = [], action) {
  switch (action.type) {
    case 'UPDATE_VISIBILITY_TYPES':
      return action.visibilityTypes;
    case 'LOGOUT':
      return [];
    default:
      return state;
  }
}



// WEBPACK FOOTER //
// ./src/reducers/visibilityTypes.js